import React from 'react';

import { useDispatch } from '@lumapps/redux/react';

import { actions } from '../../ducks/slice';

export type PageContext = Record<string, string>;

/**
 * Set generic page context data.
 *
 * Stores raw page data in Redux. Analytics and agent packages extract/transform as needed.
 *
 * Stores:
 * - pageType, pageEntityId, pageTitle (from Page component)
 * - Any other custom fields
 *
 * @param context - Page context object with key-value pairs
 *
 * @example
 * usePageContext({
 *   pageType: 'content',
 *   pageTitle: 'My Article',
 *   pageEntityId: '123',
 * });
 */
export const usePageContext = (context: PageContext) => {
    const dispatch = useDispatch();

    React.useEffect(() => {
        // Filter out empty values
        const validContext: PageContext = {};
        for (const [key, value] of Object.entries(context)) {
            if (value) {
                validContext[key] = value;
            }
        }

        // Single dispatch - stores in generic pageContext
        dispatch(actions.setPageContext(Object.keys(validContext).length > 0 ? validContext : undefined));
    }, [dispatch, context]);
};
